import LumaResourceWorkspace, {lumaMoney} from '../../../components/admin/LumaResourceWorkspace';
import AdminTable from '../../../components/admin/AdminTable';
﻿import React, { useState, useEffect, useCallback } from 'react';
import Loading from '../../../components/Loading';
import { Edit, Trash2, Plus, History, TicketPercent } from 'lucide-react';
import { fetchCupones, Cupon } from '../../../services/couponService';
import AddModalCupon from '../../../components/Coupon/AddModalCupon';
import EditModalCupon from '../../../components/Coupon/EditModalCupon';
import DeleteModalCupon from '../../../components/Coupon/DeleteModalCupon';
import Pagination from '../../../components/Pagination/Pagination';
import ExpiredSessionModal from '../../../components/Expired/ExpiredSessionModal';
import { useSessionExpiration } from '../../../hooks/useSessionExpiration';
import { useAuth } from '../../../context/AuthContext';
import { useModelPermission } from '../../../hooks/useModelPermission';
import { useNavigate } from 'react-router-dom';

const ITEMS_PER_PAGE = 10;

const CouponPage: React.FC = () => {
    const [cupones, setCupones] = useState<Cupon[]>([]);
    const [currentPage, setCurrentPage] = useState(1);

    const [mostrarModalAgregar, setMostrarModalAgregar] = useState(false);
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false);
    const [cuponEditar, setCuponEditar] = useState<Cupon | null>(null);

    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false);
    const [cuponEliminar, setCuponEliminar] = useState<Cupon | null>(null);

    const { isSessionExpired, setIsSessionExpired } = useSessionExpiration();
    const { logout, user } = useAuth();
    const navigate = useNavigate();

    const userLevelId = user?.user_level_id ?? 0;
    const perm = useModelPermission('cupon', userLevelId);

    const cargarCupones = useCallback(async () => {
        try {
            if (perm?.can_read) {
                const data = await fetchCupones();
                const ordenados = data.sort((a, b) => 
                    new Date(b.fecha_creacion).getTime() - new Date(a.fecha_creacion).getTime()
                );
                setCupones(ordenados);
            } else {
                setCupones([]);
            }
        } catch (error) {
            /* Browser diagnostics omitted. */
            setCupones([]);
        }
    }, [perm]);

    useEffect(() => {
        cargarCupones();
    }, [cargarCupones]);

    // Paginación
    const totalPages = Math.ceil(cupones.length / ITEMS_PER_PAGE);
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const cuponesMostrados = cupones.slice(startIndex, startIndex + ITEMS_PER_PAGE);

    const abrirModalEditar = (cupon: Cupon) => {
        setCuponEditar(cupon);
        setMostrarModalEditar(true);
    };

    const abrirModalEliminar = (cupon: Cupon) => {
        setCuponEliminar(cupon);
        setMostrarModalEliminar(true);
    };

    if (perm === null) return <Loading text="Cargando cupones..." />;

    return <><LumaResourceWorkspace title="Cupones" description="Consulta y gestiona la información de tu coworking." group="Cupones" rows={cupones} columns={[{key:'codigo',label:'Código'},{key:'descripcion',label:'Descripción'},{key:'descuento_monto',label:'Descuento monto',render:r=>lumaMoney(r.descuento_monto)},{key:'descuento_porcentaje',label:'Descuento %'},{key:'fecha_inicio',label:'Fecha inicio'},{key:'fecha_fin',label:'Fecha fin'}]} idKey="id" nameKey="codigo" statusKey="estado" canRead={perm?.can_read} onCreate={perm?.can_create?()=>{setMostrarModalAgregar(true)}:undefined} onEdit={perm?.can_update?r=>{setCuponEditar(r);setMostrarModalEditar(true);}:undefined} onDelete={perm?.can_delete?r=>{setCuponEliminar(r);setMostrarModalEliminar(true);}:undefined}/>{mostrarModalAgregar && (
                    <AddModalCupon
                        onClose={() => setMostrarModalAgregar(false)}
                        onSuccess={() => {
                            setMostrarModalAgregar(false);
                            cargarCupones();
                        }}
                    />
                )}{mostrarModalEditar && cuponEditar && (
                    <EditModalCupon
                        cupon={cuponEditar}
                        onClose={() => {
                            setMostrarModalEditar(false);
                            setCuponEditar(null);
                        }}
                        onSuccess={() => {
                            setMostrarModalEditar(false);
                            setCuponEditar(null);
                            cargarCupones();
                        }}
                    />
                )}<DeleteModalCupon
                    isOpen={mostrarModalEliminar}
                    cupon={cuponEliminar}
                    onClose={() => {
                        setMostrarModalEliminar(false);
                        setCuponEliminar(null);
                    }}
                    onDeleted={() => {
                        setMostrarModalEliminar(false);
                        setCuponEliminar(null);
                        cargarCupones();
                    }}
                /><ExpiredSessionModal
                    isOpen={isSessionExpired}
                    onClose={async () => {
                        setIsSessionExpired(false);
                        await logout();
                    }}
                /></>;
};

export default CouponPage;

